import { useInventoryActionsContext } from "domain/Inventory";
import { useEffect, useState } from "react";
import { NotesEvent } from "../inventory-display-notes-event/item-display-notes-event";

export const ItemDisplayNotes = ({ item }) => {

  const { getNotesById } = useInventoryActionsContext();
  const [notes, setNotes] = useState([]);
  const [showExtraInfo, setShowExtraInfo] = useState(false);

  useEffect(() => {
    getNotesById(item.id)
      .then((data) => {
        setNotes(data);
      })
      .catch(console.error);
  }, [getNotesById, item, item.id]);

  return (
    <div className="container">
      <div className="row row--column">
        {notes.map((note) => (
          <NotesEvent key={note.id} event={note} showAllExtraInfo={showExtraInfo}></NotesEvent>
        ))}
      </div>
    </div>
  );
};